import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { BusinessAuthService } from '../services/business-auth.service';

export const businessAuthGuard: CanActivateFn = () => {
  const auth = inject(BusinessAuthService);
  const router = inject(Router);

  if (auth.isLoggedIn()) {
    return true;
  }
  router.navigate(['/empresas/iniciar-sesion']);
  return false;
};
